import { StyleSheet } from 'react-native';

const ResourceMovieButtonImage = ({ style }) => {
  const oneX = require('./resource-movie-button.jpg');
  const twoX = require('./resource-movie-button@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={StyleSheet.flatten(style)}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceMovieButtonImage };
